import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { isNative, isIOS, isAndroid } from "@/lib/platform";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  // On native iOS/Android, show toasts at bottom ABOVE the nav bar
  const isNativeMobile = isNative() && (isIOS() || isAndroid());
  const position = isNativeMobile ? 'bottom-center' : 'top-center';

  // 130px = 64px nav + ~50px safe area buffer + 16px padding
  // This positions the toast ABOVE the bottom navigation
  const offset = isNativeMobile ? 130 : 16;

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position={position}
      visibleToasts={1}
      duration={1500}
      richColors
      closeButton
      offset={offset}
      toastOptions={{
        classNames: {
          toast: `group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg ${isNativeMobile ? 'native-toast-position' : ''}`,
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
